/**
 * Fixed IngredientsWidget v2 - Handles missing ingredients properly
 * 
 * Root Cause: The original widget skips ingredients that are not found in the 
 * ingredients data, causing the first few ingredients to be missing from the display.
 * 
 * This version ensures all ingredients are displayed, even if detailed data is missing.
 */
function IngredientsWidget() {
    var m = this,
        h = null,
        y = null,
        b = false,
        N = false;

    /**
     * Fixed function to fetch ingredients with JSON preprocessing
     */
    var g = function(callback) {
        fetch("/pages/ingredients-api")
            .then(function(response) {
                return response.text(); // Get as text first
            })
            .then(function(text) {
                // Fix the malformed JSON by replacing single quotes with double quotes
                var fixedText = text.replace(
                    /"next_page":\s*'([^']+)'/g, 
                    '"next_page":"$1"'
                );
                
                fixedText = fixedText.replace(
                    /"([^"]+)":\s*'([^']+)'/g,
                    '"$1":"$2"'
                );
                
                try {
                    var data = JSON.parse(fixedText);
                    
                    // Process ingredients data
                    var ingredients = data.ingredients;
                    var o = {};
                    for (var i = 0; i < ingredients.length; i++) {
                        o[ingredients[i].handle] = ingredients[i];
                    }
                    h = o;
                    b = true;
                    
                    if (typeof callback === "function") {
                        callback.call(m);
                    }
                } catch (parseError) {
                    console.error("Error parsing fixed JSON:", parseError);
                    console.log("Fixed text sample:", fixedText.substring(0, 1000));
                }
            })
            .catch(function(error) {
                console.error("Error fetching ingredients:", error);
            });
    };

    /**
     * Fixed function to fetch products with JSON preprocessing
     */
    var O = function(callback) {
        fetch("/pages/products-api")
            .then(function(response) {
                return response.text(); // Get as text first
            })
            .then(function(text) {
                // Fix the malformed JSON
                var fixedText = text.replace(
                    /"next_page":\s*'([^']+)'/g, 
                    '"next_page":"$1"'
                );
                
                fixedText = fixedText.replace(
                    /"([^"]+)":\s*'([^']+)'/g,
                    '"$1":"$2"'
                );
                
                try {
                    var data = JSON.parse(fixedText);
                    y = data;
                    N = true;
                    
                    if (typeof callback === "function") {
                        callback.call(m);
                    }
                } catch (parseError) {
                    console.error("Error parsing fixed products JSON:", parseError);
                }
            })
            .catch(function(error) {
                console.error("Error fetching products:", error);
            });
    };

    /**
     * Render ingredient template
     */
    var T = function(e) {
        if (!e) return "";
        
        var html = '\n            <div class="container">\n                <div class="row grid gap-5 grid-cols-1 lg:grid-cols-2">\n                    <div class="col-span-1">\n                  \n                            <img style="width:100%; height: 220px; object-fit: cover;" src="' + e.image.src + '" alt="' + e.image.alt + '">\n                     \n                    </div>\n                    <div class="col-span-1">\n                        <p class="p-strong"><strong>' + e.title + '</strong><br><em>' + e.excerpt + '</em></p>\n        ';
        
        if (e.metafields.function) {
            html += '<p class="font-9"><span style="font-weight: bold;">FUNCTION</span><br />' + e.metafields.function + '</p>';
        }
        
        if (e.metafields.benefit) {
            html += '<p class="font-9"><span style="font-weight: bold;">BENEFIT</span><br />' + e.metafields.benefit + '</p>';
        }
        
        if (e.metafields.ewg_ranking) {
            html += '<p class="font-9"><span style="font-weight: bold;">EWG RATING:</span> ' + e.metafields.ewg_ranking + '</p>';
        }
        
        html += "</div></div></div>";
        return html;
    };

    /**
     * Convert ingredient handle to display name
     */
    var handleToDisplayName = function(handle) {
        // Remove "ingredients/" prefix and convert to readable name
        var name = handle.replace('ingredients/', '');
        
        // Handle special cases
        var specialNames = {
            'water': 'Water',
            'sodium-lauroyl-methyl-isethionate': 'Sodium Lauroyl Methyl Isethionate',
            'sodium-cocoyl-isethionate-coconut-source': 'Sodium Cocoyl Isethionate (Coconut Source)',
            'propanediol': 'Propanediol',
            'cocamidopropyl-betaine': 'Cocamidopropyl Betaine',
            'sodium-methyl-oleoyl-taurate-1': 'Sodium Methyl Oleoyl Taurate',
            'glycerin': 'Glycerin',
            'decyl-glucoside': 'Decyl Glucoside',
            'coco-glucoside': 'Coco-Glucoside'
        };
        
        if (specialNames[name]) {
            return specialNames[name];
        }
        
        // Convert kebab-case to Title Case
        return name.split('-').map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    };

    /**
     * Generate full ingredients list with footnotes - FIXED VERSION
     */
    var F = function(e) {
        var t = e.allIngredients ? e.allIngredients.split("|") : [];
        var l = [];
        var html = "";
        
        console.log("Processing ingredients list:", t.length, "ingredients");
        console.log("First 5 ingredients:", t.slice(0, 5));
        
        // Process footnotes
        t.forEach(function(f) {
            if (f === "ingredients/aroma") {
                l.push(e.aromaFootnoteTitle);
                var p = e.aromaIngredients.split("|");
                p.forEach(function(a) {
                    var n2 = h[a];
                    if (n2 && n2.metafields.footnotes) {
                        var footnotes2 = n2.metafields.footnotes.split("|");
                        footnotes2.forEach(function(r) {
                            if (!l.includes(r)) l.push(r);
                        });
                    }
                });
            } else {
                var n = h[f];
                if (n && n.metafields.footnotes) {
                    var footnotes = n.metafields.footnotes.split("|");
                    footnotes.forEach(function(r) {
                        if (!l.includes(r)) l.push(r);
                    });
                }
            }
        });

        var u = [];
        
        // Process ingredients - FIXED to handle missing ingredients
        t.forEach(function(f, index) {
            console.log(`Processing ingredient ${index}: ${f}`);
            
            if (f === "ingredients/aroma") {
                var i = [];
                var p = e.aromaIngredients.split("|");
                i.push(l.indexOf(e.aromaFootnoteTitle) + 1);
                
                p.forEach(function(a) {
                    var n2 = h[a];
                    if (n2 && n2.metafields.footnotes) {
                        var footnotes2 = n2.metafields.footnotes.split("|");
                        footnotes2.forEach(function(r) {
                            var c = l.indexOf(r) + 1;
                            if (!i.includes(c)) i.push(c);
                        });
                    }
                });
                
                i.sort();
                u.push("Aroma <sup>" + i.join(",") + "</sup>");
            } else {
                var n = h[f];
                if (n) {
                    // Ingredient found in data - use detailed info
                    if (!n.metafields.footnotes) {
                        u.push(v(n));
                    } else {
                        var footnotes = n.metafields.footnotes.split("|");
                        var i = [];
                        footnotes.forEach(function(r) {
                            return i.push(l.indexOf(r) + 1);
                        });
                        i.sort();
                        u.push(v(n) + "<sup>" + i.join(",") + "</sup>");
                    }
                    console.log(`✓ Found data for: ${f} -> ${n.excerpt}`);
                } else {
                    // Ingredient not found in data - use fallback display name
                    var displayName = handleToDisplayName(f);
                    u.push('<span data-ingredient="' + f + '">' + displayName + '</span>');
                    console.log(`✗ Missing data for: ${f} -> using fallback: ${displayName}`);
                }
            }
        });

        console.log("Final ingredients list:", u.length, "items");
        console.log("First 5 processed:", u.slice(0, 5));

        html += '<p class="font-9">' + u.join(", ") + '</p><p class="font-9">';
        
        // Add footnotes
        l.forEach(function(I, index) {
            if (I === e.aromaFootnoteTitle) {
                var u2 = [];
                var p = e.aromaIngredients.split("|");
                p.forEach(function(a) {
                    var n = h[a];
                    if (n) {
                        if (!n.metafields.footnotes) {
                            u2.push(v(n));
                        } else {
                            var footnotes = n.metafields.footnotes.split("|");
                            var i = [];
                            footnotes.forEach(function(r) {
                                return i.push(l.indexOf(r) + 1);
                            });
                            i.sort();
                            u2.push(v(n) + "<sup>" + i.join(",") + "</sup>");
                        }
                    }
                });
                html += "<sup>" + (index + 1) + "</sup> " + e.aromaFootnoteTitle + ": " + u2.join(", ") + "<br />";
            } else {
                html += "<sup>" + (index + 1) + "</sup> " + I + "<br />";
            }
        });
        
        return html + "</p>";
    };

    /**
     * Create ingredient span
     */
    var v = function(e) {
        return '<span data-ingredient="' + e.handle + '">' + e.excerpt + '</span>';
    };

    // Public methods
    this.preloadIngredients = function() {
        g();
    };

    this.preloadProducts = function() {
        O();
    };

    this.renderFlyout = function(e) {
        g(function() {
            var html = "";
            var keyIngredients = e.keyIngredients ? e.keyIngredients.split("|") : [];
            
            html += '<div class="key-ingredients-flyout">';
            keyIngredients.forEach(function(key) {
                html += T(h[key]);
            });
            html += "</div>";
            
            if (e.headline) {
                html += '<p class="font-9">' + e.headline + '</p>';
            }
            
            if (e.header) {
                html += '<p class="font-9">' + e.header + '</p>';
            }
            
        if (e.allIngredients) {
            var ingredientsHtml = F(e);
            if (ingredientsHtml.startsWith('<p class="font-9">')) {
            var ingredientsContent = ingredientsHtml.substring('<p class="font-9">'.length);
            html += '\n                    <p class="font-9">\n                        <span style="font-weight: bold;">FULL INGREDIENTS LIST:</span> ' + ingredientsContent;
            } else {
            html += '\n                    <p class="font-9">\n                        <span style="font-weight: bold;">FULL INGREDIENTS LIST:</span> ' + ingredientsHtml + '\n                    </p>';
        }
}
            
            html += '\n                <p class="font-9">\n                    <em>Please note that ingredients and certifications may change or vary from time to time. \n                    Please refer to the product package you receive for the most up to date information.</em>\n                </p>';
            
            document.querySelector(e.selector).innerHTML = html;
        });
    };
}

// Enhanced monkey patch that also fixes the missing ingredients issue
function patchIngredientsWidgetV2() {
    if (typeof IngredientsWidget !== 'undefined') {
        // Store original fetch function
        var originalFetch = window.fetch;
        
        // Create patched fetch that fixes JSON responses
        window.fetch = function(url, options) {
            if (url === '/pages/ingredients-api' || url === '/pages/products-api') {
                return originalFetch(url, options)
                    .then(function(response) {
                        return response.text();
                    })
                    .then(function(text) {
                        // Fix malformed JSON
                        var fixedText = text.replace(
                            /"next_page":\s*'([^']+)'/g, 
                            '"next_page":"$1"'
                        );
                        
                        fixedText = fixedText.replace(
                            /"([^"]+)":\s*'([^']+)'/g,
                            '"$1":"$2"'
                        );
                        
                        // Return a response-like object
                        return {
                            json: function() {
                                return Promise.resolve(JSON.parse(fixedText));
                            },
                            text: function() {
                                return Promise.resolve(fixedText);
                            },
                            ok: true,
                            status: 200
                        };
                    });
            }
            
            // For other URLs, use original fetch
            return originalFetch(url, options);
        };
        
        // Also patch the IngredientsWidget prototype to fix the missing ingredients issue
        if (IngredientsWidget.prototype) {
            // Store original renderFlyout if it exists
            var originalRenderFlyout = IngredientsWidget.prototype.renderFlyout;
            
            // Override with fixed version
            IngredientsWidget.prototype.renderFlyout = function(e) {
                var self = this;
                
                // Use the enhanced ingredients list function
                var enhancedF = function(e, h) {
                    var t = e.allIngredients ? e.allIngredients.split("|") : [];
                    var l = [];
                    var html = "";
                    
                    console.log("Enhanced processing:", t.length, "ingredients");
                    
                    // Process footnotes (same as original)
                    t.forEach(function(f) {
                        if (f === "ingredients/aroma") {
                            l.push(e.aromaFootnoteTitle);
                            var p = e.aromaIngredients.split("|");
                            p.forEach(function(a) {
                                var n2 = h[a];
                                if (n2 && n2.metafields.footnotes) {
                                    var footnotes2 = n2.metafields.footnotes.split("|");
                                    footnotes2.forEach(function(r) {
                                        if (!l.includes(r)) l.push(r);
                                    });
                                }
                            });
                        } else {
                            var n = h[f];
                            if (n && n.metafields.footnotes) {
                                var footnotes = n.metafields.footnotes.split("|");
                                footnotes.forEach(function(r) {
                                    if (!l.includes(r)) l.push(r);
                                });
                            }
                        }
                    });

                    var u = [];
                    
                    // Enhanced ingredient processing
                    t.forEach(function(f, index) {
                        if (f === "ingredients/aroma") {
                            var i = [];
                            var p = e.aromaIngredients.split("|");
                            i.push(l.indexOf(e.aromaFootnoteTitle) + 1);
                            
                            p.forEach(function(a) {
                                var n2 = h[a];
                                if (n2 && n2.metafields.footnotes) {
                                    var footnotes2 = n2.metafields.footnotes.split("|");
                                    footnotes2.forEach(function(r) {
                                        var c = l.indexOf(r) + 1;
                                        if (!i.includes(c)) i.push(c);
                                    });
                                }
                            });
                            
                            i.sort();
                            u.push("Aroma <sup>" + i.join(",") + "</sup>");
                        } else {
                            var n = h[f];
                            if (n) {
                                // Use existing data
                                if (!n.metafields.footnotes) {
                                    u.push('<span data-ingredient="' + n.handle + '">' + n.excerpt + '</span>');
                                } else {
                                    var footnotes = n.metafields.footnotes.split("|");
                                    var i = [];
                                    footnotes.forEach(function(r) {
                                        return i.push(l.indexOf(r) + 1);
                                    });
                                    i.sort();
                                    u.push('<span data-ingredient="' + n.handle + '">' + n.excerpt + '</span>' + "<sup>" + i.join(",") + "</sup>");
                                }
                            } else {
                                // Create fallback display name
                                var name = f.replace('ingredients/', '');
                                var displayName = name.split('-').map(function(word) {
                                    return word.charAt(0).toUpperCase() + word.slice(1);
                                }).join(' ');
                                u.push('<span data-ingredient="' + f + '">' + displayName + '</span>');
                                console.log(`Using fallback for: ${f} -> ${displayName}`);
                            }
                        }
                    });

                    html += '<p class="font-9">' + u.join(", ") + '</p><p class="font-9">';
                    
                    // Add footnotes (same as original)
                    l.forEach(function(I, index) {
                        if (I === e.aromaFootnoteTitle) {
                            var u2 = [];
                            var p = e.aromaIngredients.split("|");
                            p.forEach(function(a) {
                                var n = h[a];
                                if (n) {
                                    if (!n.metafields.footnotes) {
                                        u2.push('<span data-ingredient="' + n.handle + '">' + n.excerpt + '</span>');
                                    } else {
                                        var footnotes = n.metafields.footnotes.split("|");
                                        var i = [];
                                        footnotes.forEach(function(r) {
                                            return i.push(l.indexOf(r) + 1);
                                        });
                                        i.sort();
                                        u2.push('<span data-ingredient="' + n.handle + '">' + n.excerpt + '</span>' + "<sup>" + i.join(",") + "</sup>");
                                    }
                                }
                            });
                            html += "<sup>" + (index + 1) + "</sup> " + e.aromaFootnoteTitle + ": " + u2.join(", ") + "<br />";
                        } else {
                            html += "<sup>" + (index + 1) + "</sup> " + I + "<br />";
                        }
                    });
                    
                    return html + "</p>";
                };
                
                // Call original logic but with enhanced function
                if (originalRenderFlyout) {
                    // Temporarily replace the internal F function
                    var originalF = window.F;
                    window.F = enhancedF;
                    originalRenderFlyout.call(this, e);
                    window.F = originalF;
                } else {
                    console.log("No original renderFlyout found, using enhanced version");
                }
            };
        }
        
        console.log("IngredientsWidget v2 patched successfully");
        return true;
    }
    return false;
}

// Usage instructions:
// Option 1: Replace the entire IngredientsWidget
// var ingredientsWidget = new IngredientsWidget();

// Option 2: Enhanced patch (recommended)
// patchIngredientsWidgetV2();
// var ingredientsWidget = new IngredientsWidget();
// ingredientsWidget.preloadIngredients();
// ingredientsWidget.renderFlyout({...});